/** Цветовые стили Chip как у статусов заказов в Fulfillment. */
export const FULFILLMENT_STATUS_CHIP_STYLES = Object.freeze({
  new: { bgcolor: '#E7F0FF', color: '#3E6FB0' },
  waiting_assembly: { bgcolor: '#E7F6FF', color: '#2F6FAE' },
  assembly: { bgcolor: '#ECE8FF', color: '#6754A4' },
  picked: { bgcolor: '#E1F5E7', color: '#209657' },
  collected: { bgcolor: '#E8ECFA', color: '#5666A6' },
  // Delivery-stage variety (WB + Ozon): не все «зелёные».
  sorted: { bgcolor: '#F0EFF4', color: '#777486' },
  ready_for_pickup: { bgcolor: '#D8F2E2', color: '#147A45' },
  complete: { bgcolor: '#E7F0FF', color: '#3E6FB0' }, // Передан в доставку
  delivery: { bgcolor: '#ECE8FF', color: '#6754A4' }, // В доставке / delivering
  sold: { bgcolor: '#D8F2E2', color: '#147A45' },
  postponed_delivery: { bgcolor: '#FFF0D8', color: '#FF7658' },
  acceptance_in_progress: { bgcolor: '#FFE8D6', color: '#C45E12' }, // На приёмке
  arbitration: { bgcolor: '#FFF0D8', color: '#D86B31' },
  reshipment: { bgcolor: '#FFF0D8', color: '#D86B31' },
  return: { bgcolor: '#FFF0D8', color: '#D86B31' },
  canceled: { bgcolor: '#FDE5E8', color: '#C83E52' },
  unknown: { bgcolor: '#F0EFF4', color: '#777486' },
  // Палеты / сессии / задания
  open: { bgcolor: '#E7F0FF', color: '#3E6FB0' },
  closed: { bgcolor: '#E8ECFA', color: '#5666A6' },
  loading: { bgcolor: '#FFF0D8', color: '#D86B31' },
  shipped: { bgcolor: '#D8F2E2', color: '#147A45' },
  confirming: { bgcolor: '#FFF0D8', color: '#FF7658' },
  completed: { bgcolor: '#E1F5E7', color: '#209657' },
  partial: { bgcolor: '#FFF0D8', color: '#D86B31' },
  failed: { bgcolor: '#FDE5E8', color: '#C83E52' },
  cancelled: { bgcolor: '#F0EFF4', color: '#777486' },
  error: { bgcolor: '#FDE5E8', color: '#C83E52' },
  shipment_error: { bgcolor: '#FDE5E8', color: '#C83E52' },
  in_progress: { bgcolor: '#ECE8FF', color: '#6754A4' },
  pending: { bgcolor: '#F0EFF4', color: '#777486' },
  created: { bgcolor: '#E1F5E7', color: '#209657' },
  unapplied: { bgcolor: '#FFF0D8', color: '#D86B31' },
  skipped: { bgcolor: '#F0EFF4', color: '#777486' },
});

export function statusChipSx(code) {
  const key = String(code || 'unknown');
  const style = FULFILLMENT_STATUS_CHIP_STYLES[key] || FULFILLMENT_STATUS_CHIP_STYLES.unknown;
  return {
    ...style,
    fontWeight: 600,
  };
}

export function supplyStatusChipSx(code) {
  if (code === 'accepted') return statusChipSx('complete');
  if (code === 'rejected') return statusChipSx('canceled');
  if (code === 'awaiting_acceptance') return statusChipSx('postponed_delivery');
  return statusChipSx('assembly');
}

const PALLET_STATUS_LABEL = Object.freeze({
  open: 'Открыта',
  closed: 'Закрыта',
  loading: 'Погрузка',
  shipped: 'Отгружена',
  cancelled: 'Отменена',
});

/** Фильтр статусов палет в АРМ: пустое значение — всё кроме отменённых. */
export const PALLET_STATUS_FILTERS = Object.freeze([
  { value: '', label: 'Все активные' },
  { value: 'open', label: 'Открытые' },
  { value: 'closed', label: 'Закрытые' },
  { value: 'loading', label: 'В погрузке' },
  { value: 'shipped', label: 'Отгруженные' },
  { value: 'cancelled', label: 'Отменённые' },
]);

const LOADING_SESSION_STATUS_LABEL = Object.freeze({
  open: 'Открыта',
  confirming: 'Подтверждение',
  completed: 'Завершена',
  partial: 'Частично',
  failed: 'Ошибка',
  cancelled: 'Отменена',
});

const PICKING_JOB_STATUS_LABEL = Object.freeze({
  new: 'Новое',
  in_progress: 'В работе',
  completed: 'Закрыто',
  cancelled: 'Отменено',
});

const SESSION_LINK_STATUS_LABEL = Object.freeze({
  pending: 'Ожидает',
  ok: 'Ок',
  done: 'Готово',
  error: 'Ошибка',
  scanned: 'Отсканирована',
  transferred: 'Перенесена',
  delivered: 'Сдана',
  shipped: 'Отгружена',
  qr_printed: 'QR напечатан',
  completed: 'Завершена',
});

export function palletStatusInfo(status) {
  const code = String(status || 'unknown');
  return {
    code,
    label: PALLET_STATUS_LABEL[code] || code || 'Статус',
    sx: statusChipSx(code),
  };
}

export function loadingSessionStatusInfo(status) {
  const code = String(status || 'unknown');
  return {
    code,
    label: LOADING_SESSION_STATUS_LABEL[code] || code || 'Статус',
    sx: statusChipSx(code),
  };
}

export function pickingJobStatusInfo(status) {
  const code = String(status || 'unknown');
  return {
    code,
    label: PICKING_JOB_STATUS_LABEL[code] || code || 'Статус',
    sx: statusChipSx(code),
  };
}

export function sessionLinkStatusInfo(status) {
  const code = String(status || 'unknown');
  const styleCode = {
    scanned: 'waiting_assembly',
    transferred: 'assembly',
    delivered: 'collected',
    shipped: 'shipped',
    qr_printed: 'picked',
    completed: 'completed',
    ok: 'complete',
    done: 'complete',
    error: 'failed',
    pending: 'pending',
  }[code] || code;
  return {
    code,
    label: SESSION_LINK_STATUS_LABEL[code] || code || 'Статус',
    sx: statusChipSx(styleCode),
  };
}

export function msDemandStatusInfo(status) {
  const code = String(status || 'unknown');
  const labels = {
    pending: 'МС после подтверждения',
    created: 'МС создан',
    unapplied: 'МС без остатка',
    skipped: 'МС пропущен',
    error: 'Ошибка МС',
  };
  return {
    code,
    label: labels[code] || code || 'МС',
    sx: statusChipSx(code === 'error' ? 'failed' : code === 'pending' ? 'pending' : code),
  };
}

/** Красный чип ошибки отгрузки — поверх статуса палеты. */
export function shipmentErrorChipInfo() {
  return {
    code: 'shipment_error',
    label: 'Ошибка отгрузки',
    sx: statusChipSx('failed'),
  };
}

export function formatOrderAge(createdAt, now = Date.now()) {
  const created = new Date(createdAt).getTime();
  const current = now instanceof Date ? now.getTime() : Number(now);
  if (!Number.isFinite(created) || !Number.isFinite(current)) return 'Возраст неизвестен';
  const minutes = Math.max(0, Math.floor((current - created) / 60000));
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  if (hours === 0) return `${rest} мин назад`;
  return `${hours} ч ${rest} мин назад`;
}

export function orderAgeTone(createdAt, now = Date.now()) {
  const created = new Date(createdAt).getTime();
  const current = now instanceof Date ? now.getTime() : Number(now);
  if (!Number.isFinite(created) || !Number.isFinite(current)) return 'default';
  const hours = Math.max(0, (current - created) / 3600000);
  if (hours < 20) return 'success';
  if (hours < 50) return 'warning';
  if (hours < 80) return 'error';
  return 'critical';
}

export function normalizedStatus(task = {}) {
  return task.normalized_status || {
    code: 'unknown',
    label: 'Статус уточняется',
    color: 'default',
  };
}

export function displayArticle(task = {}) {
  const article = [task.product?.article, task.article]
    .map((value) => (value == null ? '' : String(value).trim()))
    .find(Boolean);
  return article || 'Артикул не указан';
}

/**
 * Строка идентификаторов под артикулом: WB `nmID … · ШК …`, Ozon `SKU … · ШК …`.
 * @param {object} [task]
 * @param {{ sku?: *, nmId?: *, barcode?: *, marketplace?: string }} [overrides]
 */
export function productIdentifiersLine(task = {}, overrides = {}) {
  const marketplace = overrides.marketplace || taskMarketplace(task);
  const barcode = overrides.barcode != null
    ? overrides.barcode
    : (task.barcode || task.product?.barcode || null);
  const sku = overrides.sku != null
    ? overrides.sku
    : (task.product?.sku ?? task.sku ?? task.nm_id ?? null);
  const nmId = overrides.nmId != null
    ? overrides.nmId
    : (task.nm_id ?? null);
  if (marketplace === 'ozon' || marketplace === 'yandex') {
    return `SKU ${sku != null && sku !== '' ? sku : '—'} · ШК ${barcode || '—'}`;
  }
  return `nmID ${nmId != null && nmId !== '' ? nmId : '—'} · ШК ${barcode || '—'}`;
}

/** Стабильный ключ строки в едином списке WB/Ozon. */
export function taskExternalId(task = {}) {
  if (task.external_id != null && String(task.external_id).trim() !== '') {
    return String(task.external_id);
  }
  if (task.wb_order_id != null && String(task.wb_order_id).trim() !== '') {
    return String(task.wb_order_id);
  }
  if (task.posting_number != null && String(task.posting_number).trim() !== '') {
    return String(task.posting_number);
  }
  if (task.yandex_order_id != null && String(task.yandex_order_id).trim() !== '') {
    return String(task.yandex_order_id);
  }
  return '';
}

export function taskMarketplace(task = {}) {
  const raw = String(task.marketplace || '').toLowerCase();
  if (raw === 'ozon' || raw === '2') return 'ozon';
  if (raw === 'yandex' || raw === '3' || raw === 'ym') return 'yandex';
  if (raw === 'wb' || raw === '1') return 'wb';
  if (task.posting_number && !task.wb_order_id) return 'ozon';
  return 'wb';
}

export function marketplaceChipLabel(marketplace) {
  if (marketplace === 'ozon') return 'Ozon';
  if (marketplace === 'wb') return 'WB';
  if (marketplace === 'yandex') return 'Яндекс';
  return String(marketplace || 'МП').toUpperCase();
}

export function cargoTypeInfo(value) {
  const type = Number(value);
  if (type === 2) return { code: 'sgt', label: 'СГТ' };
  if (type === 1) return { code: 'mgt', label: 'МГТ' };
  if (type === 3) return { code: 'kgt', label: 'КГТ+' };
  return { code: 'unknown', label: 'Тип не определён' };
}

export function warehousePresentation(task = {}, warehouseName = '') {
  const warehouseId = task.warehouse_id == null ? '' : String(task.warehouse_id).trim();
  const name = String(warehouseName || task.warehouse_label || '').trim();
  return {
    warehouseLabel: name || (warehouseId ? `Склад №${warehouseId}` : 'Склад не указан'),
    cargo: cargoTypeInfo(task.cargo_type),
  };
}

export function deliveryTypeLabel(value) {
  const type = String(value || '').toLowerCase();
  if (type === 'fbs') return 'FBS';
  if (type === 'wbgo') return 'WB Курьер';
  return value ? String(value).toUpperCase() : 'WB FBS';
}

/** Вкладки рабочего потока: сверху самые старые задания (created_at_mp ASC). */
export const OLDEST_FIRST_STATUS_GROUPS = Object.freeze([
  'new',
  'waiting_assembly',
  'assembly',
]);

export function defaultTaskSort(statusGroup) {
  const oldestFirst = OLDEST_FIRST_STATUS_GROUPS.includes(String(statusGroup || '').toLowerCase());
  return { key: 'created_at_mp', dir: oldestFirst ? 'asc' : 'desc' };
}

/** Стабильный ключ вкладки АРМ: не сдвигается, когда wbOnly-вкладка скрыта. */
export function fulfillmentTabKey(tab) {
  if (!tab || typeof tab !== 'object') return '';
  if (tab.key) return String(tab.key);
  return `${tab.kind || 'tasks'}:${tab.statusGroup || ''}`;
}

/** Индекс видимой вкладки по ключу. Нет ключа (например, «Перепоставка» на Ozon) → 0. */
export function resolveVisibleTabIndex(tabs, tabKey) {
  const list = Array.isArray(tabs) ? tabs : [];
  const idx = list.findIndex((item) => fulfillmentTabKey(item) === tabKey);
  return idx < 0 ? 0 : idx;
}

/** Артикул листа подбора: offer_id из карточки (product.article), иначе article задания. */
export function pickingListArticle(task = {}) {
  return displayArticle(task);
}

function taskQty(task = {}) {
  const raw = Number(task.quantity ?? task.qty);
  return Number.isFinite(raw) && raw > 0 ? Math.trunc(raw) : 1;
}

/**
 * Агрегация заказов в строки листа подбора: один артикул → одна строка, qty суммируется.
 * Ozon multi-SKU: разворачивает `products[]` (как в ЛК). WB — одна строка на задание.
 * Сортировка по артикулу asc (ru).
 */
export function aggregatePickingListByArticle(tasks = []) {
  const map = new Map();
  const bump = (article, qty, orderDelta = 1) => {
    const key = String(article || 'Артикул не указан');
    const prev = map.get(key) || { article: key, qty: 0, order_count: 0 };
    prev.qty += qty;
    prev.order_count += orderDelta;
    map.set(key, prev);
  };
  for (const task of tasks || []) {
    const products = Array.isArray(task?.products) ? task.products.filter(Boolean) : [];
    if (products.length > 0) {
      for (const item of products) {
        const article = item.article || item.offer_id || pickingListArticle(task);
        const qtyRaw = Number(item.quantity ?? item.qty);
        const qty = Number.isFinite(qtyRaw) && qtyRaw > 0 ? Math.trunc(qtyRaw) : 1;
        bump(article, qty, 1);
      }
      continue;
    }
    bump(pickingListArticle(task), taskQty(task), 1);
  }
  return [...map.values()].sort((a, b) => String(a.article).localeCompare(String(b.article), 'ru', {
    sensitivity: 'base',
    numeric: true,
  }));
}

/** Имя файла листа подбора по дате (МСК). */
export function pickingListFilename(date = new Date()) {
  const safe = date instanceof Date ? date : new Date(date);
  const stamp = Number.isNaN(safe.getTime())
    ? new Date()
    : safe;
  const ymd = stamp.toLocaleString('sv-SE', { timeZone: 'Europe/Moscow' }).slice(0, 10);
  return `list-podbora-${ymd}.pdf`;
}

/**
 * Скачивает PDF через <a download> без window.open/print.
 * После async fetch popup-блокер режет window.open — download надёжнее.
 * @returns {'downloaded'}
 */
export function openOrDownloadPdfBlob(blob, filename) {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    throw new Error('Скачивание PDF доступно только в браузере');
  }
  if (!(blob instanceof Blob) || blob.size === 0) {
    throw new Error('Пустой PDF');
  }
  const url = URL.createObjectURL(blob);
  const safeName = String(filename || pickingListFilename()).replace(/[^\w.\-а-яА-ЯёЁ]+/gi, '_');
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = safeName;
  anchor.rel = 'noopener noreferrer';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
  return 'downloaded';
}

const BULK_REASON_LABELS = Object.freeze({
  already_waiting_assembly: 'Уже в «Ожидают сборки»',
  already_new: 'Уже в «Новые»',
});

function bulkIssueId(item) {
  if (item == null || typeof item !== 'object') return String(item ?? '').trim();
  const raw = item.wb_order_id
    ?? item.posting_number
    ?? item.yandex_order_id
    ?? item.external_id
    ?? item.order_id
    ?? item.id;
  return raw == null ? '' : String(raw).trim();
}

function bulkIssueList(list, fallbackReason = '') {
  if (!Array.isArray(list)) return [];
  return list.map((item) => {
    const id = bulkIssueId(item);
    const rawReason = item && typeof item === 'object' ? String(item.reason || '').trim() : '';
    const reason = BULK_REASON_LABELS[rawReason] || rawReason || fallbackReason;
    return { id, reason };
  }).filter((item) => item.id || item.reason);
}

function bulkOkCount(result) {
  if (Array.isArray(result.moved)) return result.moved.length;
  if (Array.isArray(result.accepted)) return result.accepted.length;
  if (Array.isArray(result.yandex_order_ids) && typeof result.updated === 'number') {
    return result.yandex_order_ids.length;
  }
  if (Array.isArray(result.posting_numbers) && typeof result.updated === 'number') {
    return result.posting_numbers.length;
  }
  if (typeof result.updated === 'number') return result.updated;
  return null;
}

/**
 * Сводка массового действия WB `{ moved|accepted, skipped, rejected }`
 * и Ozon/Yandex `{ updated, skipped, not_found }`.
 */
export function summarizeBulkResult(result, ids = []) {
  const data = result && typeof result === 'object' ? result : {};
  const skipped = [
    ...bulkIssueList(data.skipped),
    ...bulkIssueList(data.already_in_target, 'Уже в этой поставке'),
  ];
  const rejected = [
    ...bulkIssueList(data.rejected),
    ...bulkIssueList(data.not_found, 'Заказ не найден'),
  ];
  const counted = bulkOkCount(data);
  const okCount = counted == null
    ? Math.max(0, (Array.isArray(ids) ? ids.length : 0) - skipped.length - rejected.length)
    : counted;
  return { okCount, skipped, rejected };
}

/** Текст уведомления: «Передано: N» или частичный успех с причинами (до 5 строк). */
export function formatBulkNotice(summary) {
  const okCount = Number(summary?.okCount) || 0;
  const missed = [...(summary?.skipped || []), ...(summary?.rejected || [])];
  if (!missed.length) {
    return { severity: 'success', text: `Передано: ${okCount}` };
  }
  const lines = missed.slice(0, 5).map((item) => {
    const id = item.id ? `№ ${item.id}` : '№ —';
    return item.reason ? `${id} — ${item.reason}` : id;
  });
  const rest = missed.length - lines.length;
  if (rest > 0) lines.push(`и ещё ${rest}`);
  return {
    severity: okCount === 0 ? 'error' : 'warning',
    text: [`Передано: ${okCount}. Пропущено: ${missed.length}`, ...lines].join('\n'),
  };
}

const ERROR_LABELS = Object.freeze({
  write_disabled: 'Управление для этого кабинета выключено.',
  emergency_stop: 'Операции остановлены стоп-краном.',
  supply_closed: 'Поставка уже закрыта.',
  supply_not_empty: 'Непустую поставку удалить нельзя.',
  invalid_transition: 'Операция недоступна в текущем статусе.',
  idempotency_in_progress: 'Операция уже выполняется. Обновите данные через несколько секунд.',
  shipping_method_required: 'Не удалось подобрать пункт отгрузки. Выберите город и склад отгрузки.',
  confirm_in_progress: 'Передача в сборку уже выполняется.',
  labels_in_progress: 'Этикетки Яндекса уже формируются.',
});

const LABEL_FIRST_CODES = new Set([
  'write_disabled',
  'emergency_stop',
  'idempotency_in_progress',
  'confirm_in_progress',
  'labels_in_progress',
]);

const TECHNICAL_STATUS_RE = /packer_status=|supplier_status=/;

/**
 * Текст ошибки для оператора.
 * Сначала человеческий `message`, кроме кодов, где бэкенд-текст хуже справочника.
 */
export function humanizeError(data, fallback = 'Не удалось выполнить операцию') {
  const payload = data && typeof data === 'object' ? data : {};
  const code = payload.code;
  const message = String(payload.message || '').trim();
  const labeled = ERROR_LABELS[code];
  if (LABEL_FIRST_CODES.has(code) && labeled) return labeled;
  if (message && !TECHNICAL_STATUS_RE.test(message)) return message;
  if (labeled) return labeled;
  return message || fallback;
}

export const PALLET_PRINT_AFTER_CLOSE_KEY = 'fulfillment.pallet.printLabelAfterClose';

export function readPalletPrintAfterClose() {
  try {
    const saved = localStorage.getItem(PALLET_PRINT_AFTER_CLOSE_KEY);
    if (saved == null || saved === '') return true;
    return saved === '1';
  } catch {
    return true;
  }
}

export function writePalletPrintAfterClose(enabled) {
  try {
    localStorage.setItem(PALLET_PRINT_AFTER_CLOSE_KEY, enabled ? '1' : '0');
  } catch {
    /* приватный режим — чекбокс живёт только в этой сессии */
  }
}

/** Подпись техкарты МойСклад для диалога создания производства. */
export function techCardLabel(card) {
  if (!card) return '';
  const processName = String(card.name_process || '').trim();
  const name = String(card.name || '').trim();
  if (processName && name && processName !== name) return `${processName} — ${name}`;
  return processName || name || String(card.id || '');
}
